/* Progressive enhancement for otherwise-native add forms. Cart and age-check navigation stay intact.
   ES2017 only: Shopify minifies this file but does not transpile it, and iOS 12 Safari
   (still seen on iPads) rejects the whole file with a SyntaxError on optional chaining. */
(function (scope) {
  'use strict';
  if (!scope.fetch || !scope.FormData || scope.__dirtNativeCart) return;
  scope.__dirtNativeCart = true;
  const pending = new WeakSet();
  scope.document.addEventListener('submit', async event => {
    const form = event.target, button = event.submitter;
    if (!form || form.tagName !== 'FORM') return;
    if (pending.has(form)) { event.preventDefault(); return; }
    if (event.defaultPrevented || (button && button.disabled)) return;
    let action, body;
    try {
      if (form.getAttribute('target') !== null || ['formaction','formmethod','formtarget'].some(name => button && button.getAttribute(name) != null)) return;
      action = new URL(form.getAttribute('action') || '', scope.location.href);
      if (action.origin !== new URL(scope.location.href).origin || !/\/cart\/add(?:\.js)?$/.test(action.pathname) || String(form.getAttribute('method')).toLowerCase() !== 'post') return;
      body = new scope.FormData(form, button);
      if (body.has('return_to') || action.searchParams.has('return_to')) return;
    } catch (_) { return; }
    event.preventDefault();
    if (pending.has(form)) return;
    pending.add(form);
    const cart = new URL(action); cart.pathname = cart.pathname.replace(/\/add(?:\.js)?$/, ''); cart.search = '';
    const current = new URL(scope.location.href);
    for (const key of ['preview_theme_id', 'preview_key', 'preview', '_fd', 'pb']) if (current.searchParams.has(key)) cart.searchParams.set(key, current.searchParams.get(key));
    action.pathname = action.pathname.replace(/(?:\.js)?$/, '.js'); action.search = '';
    form.setAttribute('aria-busy', 'true');
    if (button) button.disabled = true;
    let uncertain = true;
    try {
      const response = await scope.fetch(action.href, {method:'POST',headers:{Accept:'application/json'},body});
      if (!response.ok) { uncertain = response.status >= 500; throw Error('rejected'); }
      uncertain = true;
      const result = await response.json();
      const lines = result && Array.isArray(result.items) ? result.items : result && result.id ? [result] : [];
      if (!lines.length || lines.some(line => !(line.variant_id || line.id) || !(line.quantity > 0))) throw Error('unconfirmed');
      scope.document.dispatchEvent(new scope.CustomEvent('dirt:form-result',{detail:{form,status:'success'}}));
      scope.location.assign(cart.href);
    } catch (_) {
      scope.document.dispatchEvent(new scope.CustomEvent('dirt:form-result',{detail:{form,status:uncertain?'unknown':'error'}}));
      let notice = form.querySelector('[data-native-cart-status]');
      if (!notice) { notice = scope.document.createElement('p'); notice.setAttribute('data-native-cart-status',''); notice.setAttribute('role','alert'); form.appendChild(notice); }
      notice.textContent = uncertain ? 'De bevestiging ontbreekt. Controleer je winkelmand voordat je opnieuw toevoegt.' : 'Toevoegen lukt nu niet. Controleer je keuze en probeer opnieuw.';
      if (button) button.disabled = false;
      form.removeAttribute('aria-busy');
      // An ambiguous request may already have changed the cart; never replay it automatically.
      pending.delete(form);
    }
  });
})(window);
